import './styles.scss';
import ButtonCircle from '../../../shared/components/button_circle';
import { useDispatch, useSelector, selectGtoState, selectMainState } from '../../../stateManagement/redux';
import { useEffect, useState } from 'react';
import { getTaskList } from '../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers';
import { useNavigate, useLocation } from 'react-router-dom';
import { originFlowActivityType } from './config';
import { TaskList } from "../../../stateManagement/redux/slices/gerencia_tecnica/interfaces";
import { formatDate } from '../../../shared/util/functions';
import Button_small from '../../../shared/components/button_small';
import { Modal } from "../../../shared/modules/modals";


const DetailedModalModule = ({ activeTask, onClose }: { activeTask: { task: TaskList, active: string }, onClose: any }) => {

  const [activeTab, setActiveTab] = useState("alerts")

  useEffect(() => {
    setActiveTab(activeTask.active)
  }, [activeTask])


  const tabs = [
    { id: "alerts", name: "Alertas" },
    { id: "files", name: "Archivos" }
  ]

  return (
    <Modal onClose={onClose}>
      <div>
        {/* Tabs */}
        <div className='tabs_container_history'>
          {tabs.map((t, i) => (
            <div key={i} className={`tabs_container_history_tab ${activeTab === t.id && " active"}`} onClick={() => setActiveTab(t.id)} >
              {t.name}
            </div>))}
        </div>
        {/* Body */}
        <div className='list_container'>
          {activeTab === "files" && <div>{activeTask.task.originFiles?.map((f,i) => {
            return <div className='element' key={i} >{f.name}</div>
          })}</div>}
          {activeTab === "alerts" && <div>{activeTask?.task.errors?.map((e,i) => {
            return <div key={i}  className={`element ${e.type === "error" ? "error_row" : "warning_row"}`} >{e.message}</div>
          })}</div>}
        </div>

      </div>
    </Modal>)
}


export const HistoryTaskModule = () => {

  // const router = useRouter()

  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  const mainState = useSelector(selectGtoState);

  const [activeTask, setActiveTask] = useState<{ task: TaskList, active: string }>()

  const [statePagination, setStatePagination] = useState({
    activitiesPerPage: 10,
    currentPage: 1,
    typeOfActivity: ''
  })

  const totalPages = Math.ceil(mainState.totalActivities / statePagination?.activitiesPerPage);

  useEffect(() => {
    dispatch(getTaskList(statePagination.currentPage, statePagination.activitiesPerPage, statePagination.typeOfActivity))
  }, [statePagination])

  const onClose = () => {
    setActiveTask(undefined)
  }

  const filterTasks = (type: string) => {
    handleChangePaginationConfig(type, 'typeOfActivity')
  }

  const handleActivitiesPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    handleChangePaginationConfig(Number(event.target.value), 'activitiesPerPage')
  };

  const handlePageChange = (pageNumber: number) => {
    handleChangePaginationConfig(pageNumber, 'currentPage')
  };

  const generatePageNumbers = () => {
    const pages = [];
    const startPage = Math.max(1, statePagination.currentPage - 1);
    const endPage = Math.min(totalPages - 1, statePagination.currentPage + 1);

    if (startPage > 2) {
      pages.push(1, '...');
    } else if (startPage === 2) {
      pages.push(1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < totalPages - 1) {
      pages.push('...', totalPages);
    } else if (endPage === totalPages - 1) {
      pages.push(totalPages === 0 ? 1 : totalPages);
    }

    return pages;
  };

  const handleChangePaginationConfig = (newValue: any, type: 'activitiesPerPage' | 'currentPage' | 'totalPages' | 'typeOfActivity') => {

    const preValue = { ...statePagination, [type]: newValue }

    if (type === 'activitiesPerPage') {
      preValue.currentPage = 1
    }

    setStatePagination(preValue)
  }

  const onClickTaskButton = (task: TaskList, active: string) => {
    setActiveTask({ task, active })
  }



  return (
    <div className="history_task_container">
      {(activeTask) && <DetailedModalModule activeTask={activeTask} onClose={onClose} />}
      {/* Headers */}
      <div className='history_task_container_header'>
        <ButtonCircle icon="/assets/icons/back.svg" iconHeight={50} iconWidth={50} onClick={() => navigate('/gto/upload')} />
        <div className='history_task_container_title'>Historial de Tareas</div>
      </div>
      {/* Filtros */}
      <div className='history_task_container_filter_container'>
        <label htmlFor="file">Tipo Actividad : </label>
        <select id="activity" name="activity" className='' value={statePagination.typeOfActivity} onChange={(e) => filterTasks(e.target.value)}>
          <option value=''>Seleccione opcion valida</option>
          {originFlowActivityType.map((of, index) => <option key={index} value={of.id}>{of.name}</option>)}
        </select>
      </div>
      {/* table */}
      <div className='history_task_container_table_container'>
        {/* Table Header */}
        <div className='history_task_container_table_container_header'>
          <div>Tipo de Actividad</div>
          <div>Duracion</div>
          <div>Usuario</div>
          <div>Status</div>
          <div />
        </div>
        {/* Table Body */}
        {mainState?.taskList?.map((task, i) => (
          <div className='history_task_container_table_container_row' key={i}>
            <div className='history_task_container_table_container_row_info_task'>
              <div>{task.originFlow.name}</div>
              <div className='history_task_container_table_container_date_container'>
                <span>{formatDate(task.createdAt)}</span>
                <span>{formatDate(task.updatedAt)}</span>
              </div>
              <div>{task?.user?.name}</div>
              <div>{task.state}</div>
              <div>
                {(task?.errors?.length ?? 0) > 0 && <Button_small icon="/assets/icons/alertIcon.svg" text='ver errores' iconHeight={20} onClick={() => onClickTaskButton(task, 'alerts')} />}
                {(task?.originFiles?.length ?? 0) > 0 && <Button_small icon="/assets/icons/attached-files.svg" text='ver archivos' iconHeight={20} onClick={() => onClickTaskButton(task, 'files')} />}
              </div>
            </div>
          </div>))}
      </div >
      {/* Pagination Controls */}
      <div className='pagination_controls'>
        <button
          onClick={() => handlePageChange(statePagination.currentPage - 1)}
          disabled={statePagination.currentPage === 1}
          className='arrow_button'
        >
          &laquo;
        </button>
        <div className='pagination_buttons'>
          {generatePageNumbers().map((page, index) => (
            <button
              key={index}
              onClick={() => typeof page === 'number' && handlePageChange(page)}
              className={statePagination.currentPage === page ? 'button_active' : 'button'}
              disabled={typeof page !== 'number'}
            >
              {page}
            </button>
          ))}
        </div>
        <button
          onClick={() => handlePageChange(statePagination.currentPage + 1)}
          disabled={statePagination.currentPage === totalPages}
          className='arrow_button'
        >
          &raquo;
        </button>
        <select id="activitiesPerPage" value={statePagination.activitiesPerPage} onChange={handleActivitiesPerPageChange}>
          <option value={10}>10</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={200}>200</option>
        </select>
      </div>
    </div>
  )
}
